import React, { useEffect, useMemo, useRef } from 'react';
import HyperLink from 'components/Core/HyperLink';
import { STLogo } from 'components/Brand/Logos/STLogo';
import { WithNavLogoContext } from 'utils/NavLogoContext';
import { HeaderLogoContainer } from './styles';

const HeaderLogo = ({ route, type, className, ...otherProps }) => {
  const logoWrapper = useRef([]);
  const { prevLogoType = 'Default', currLogoType = 'Default' } = otherProps || {};

  const commonLogoProps = {
    className: 'header-logo--img',
    width: '168px',
    height: '28px',
  };

  useEffect(() => {
    if (currLogoType !== prevLogoType) {
      setTimeout(
        () => logoWrapper?.current?.forEach((x) => x?.classList?.add('animate-logo')),
        2000,
      );
    } else {
      logoWrapper?.current?.forEach((x) => x?.classList?.remove('animate-logo'));
    }
  }, [currLogoType]);

  const logos = useMemo(
    () => (
      <>
        <span style={{ display: 'none' }}>Logo</span>
        <div ref={(el) => (logoWrapper.current[0] = el)} className="logo-wrapper white-logo">
          <STLogo type={prevLogoType} {...commonLogoProps} />
          {prevLogoType !== currLogoType && <STLogo type={currLogoType} {...commonLogoProps} />}
        </div>
        <div ref={(el) => (logoWrapper.current[1] = el)} className="logo-wrapper tertiary-logo">
          <STLogo variation="black" type={prevLogoType} {...commonLogoProps} />
          {prevLogoType !== currLogoType && (
            <STLogo variation="black" type={currLogoType} {...commonLogoProps} />
          )}
        </div>
      </>
    ),
    [currLogoType],
  );

  return (
    <HeaderLogoContainer
      {...otherProps}
      className={`header-logo-container ${className}`}
      prevLogoType={prevLogoType}
    >
      {route ? (
        <HyperLink data-position="Header - Logo CTA" data-optimizely="header-logo" href={route}>
          {logos}
        </HyperLink>
      ) : (
        <div data-optimizely="header-logo">{logos}</div>
      )}
    </HeaderLogoContainer>
  );
};

export default WithNavLogoContext(HeaderLogo);
